export const pushDataLayerNoResultsEvent = (url?: string) => {
  window.dataLayer.push({
    event: "promoNoResults",
    promoPageLocation: url ?? "",
  } as DataLayerNoResults);
};

export interface DataLayerNoResults {
  event: string;
  promoPageLocation: string;
}
